import { Box, Divider, Stack, Typography } from '@mui/material'
import type { FC, PropsWithChildren, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import type { To } from 'react-router'

import { COLORS, unit } from '@hcr/ui'

import { LayoutNavigationBack, Metadata } from '../../../../../common'

interface LayoutOwnerBenefitsProps extends PropsWithChildren {
  backNavigationPath: To
  description: ReactNode
  title: ReactNode
}

export const LayoutOwnerBenefits: FC<LayoutOwnerBenefitsProps> = ({
  backNavigationPath,
  children,
  description,
  title,
}) => {
  const { t } = useTranslation()

  return (
    <LayoutNavigationBack to={backNavigationPath} arrowVariant='text'>
      <Metadata title={t('page-title.owner-benefits')} />
      <Box bgcolor={COLORS.white} minHeight='100vh'>
        <Stack gap={unit(4)} paddingTop={unit(24)} paddingX={unit(7)} paddingBottom={unit(4.5)}>
          <Typography component='h1' variant='headlineL'>
            {title}
          </Typography>
          <Typography component='h2' variant='bodyM'>
            {description}
          </Typography>
        </Stack>
        <Box paddingX={unit(3)}>
          <Divider />
          {children}
        </Box>
      </Box>
    </LayoutNavigationBack>
  )
}
